module.exports = __webpack_public_path__ + "img/u684.677c55c9.png";